import { ApiUrl } from "../utils/modules";

class SondageReponseServices {
  constructor(api) {
    this.api = api;
  }

  create(data) {
    return this.api.post(ApiUrl + "sondagereponse", data);
  }

  getAll() {
    return this.api.get(ApiUrl + "sondagereponse");
  }

  getOne(id) {
    return this.api.get(ApiUrl + "sondagereponse/" + id);
  }

  update(id, data) {
    return this.api.patch(ApiUrl + "sondagereponse/" + id, data);
  }

  delete(id) {
    return this.api.delete(ApiUrl + "sondagereponse/" + id);
  }

  getSondageDashboard() {
    return this.api.get(ApiUrl + "sondagereponse/dashboard");
  }

  getReponseByUser(idUser) {
    return this.api.get(ApiUrl + "sondagereponse/utilisateur/" + idUser);
  }
}

export default SondageReponseServices;
